<template>
  <svg :height="size" :width="size" fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path
      :fill="color"
      d="M24 29.6C24 25.6 20.1177 23.8801 16.0006 23.8801C11.8831 23.8801 8 25.6 8 29.6C8 29.6 9.02816 32 16.0006 32C22.9731 32 24 29.6 24 29.6Z"
    />
    <path :stroke="color" d="M22 11.2H10" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2" />
    <path :stroke="color" d="M22 17.6H10" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2" />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EdroneAvatarDashes",
  props: {
    size: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: "#545454",
    },
  },
});
</script>

<style scoped></style>
